import type { Easing, TargetAndTransition, Transition, Variants } from 'motion/react'

export const BASE_EASE: [number, number, number, number] = [0.16, 1, 0.3, 1]
export const BASE_DURATION = 0.5
export const BASE_DELAY = 0.12
export const CHILD_STAGGER = 0.12

export const tween: (ease?: Easing | Easing[], duration?: number, delay?: number) => Transition = (
	ease = BASE_EASE,
	duration = BASE_DURATION,
	delay,
) => ({
	type: 'tween',
	ease,
	duration,
	...(delay !== undefined ? { delay } : {}),
})

export const fadeUp = (duration = BASE_DURATION, delay?: number): Variants => ({
	hidden: { opacity: 0, y: 16, filter: 'blur(2px)' },
	visible: {
		opacity: 1,
		y: 0,
		filter: 'blur(0px)',
		transition: tween(BASE_EASE, duration, delay),
	},
})

export const fadeDown = (duration = BASE_DURATION, delay?: number): Variants => ({
	hidden: { opacity: 0, y: -16, filter: 'blur(2px)' },
	visible: {
		opacity: 1,
		y: 0,
		filter: 'blur(0px)',
		transition: tween(BASE_EASE, duration, delay),
	},
})

export const fadeIn = (duration = BASE_DURATION, delay?: number): Variants => ({
	hidden: { opacity: 0 },
	visible: {
		opacity: 1,
		transition: tween(BASE_EASE, duration, delay),
	},
})

export const containerStagger = (delay = BASE_DELAY, child = CHILD_STAGGER): Variants => ({
	hidden: {},
	visible: { transition: { delayChildren: delay, staggerChildren: child } },
})
